module.exports = {"shopUrl":"https://rj-netsystem.com/projets/1data/","apiUrl":"https://rj-netsystem.com/projets/1data/api/","apiKey":"818GTSWAME7Q6PXEEIECPTPDPYB2RVD5","dataType":"output_format=JSON","routeSuffix":"","postRequest":{"url":"https://rj-netsystem.com/projets/1data/webservice-api/api/"}}


//////////////////
// WEBPACK FOOTER
// ./src/utils/config.json
// module id = 13
// module chunks = 0